export const SocketRooms = {
    managers: 'managers',
    common: 'common',
};
